(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.alert = {
    attach: function (context, settings) {
      once("alert", ".alert", context).forEach(function (block) {
        $(block).on("click", ".close", function () {
          $(block).closest(".alert").slideUp(200);
        });
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
